import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import LinkButton from '../../../LinkButton';
import { useLocalisedLink } from '@parcel2go/npm-p2g-app';

interface props {
  disabled?: boolean;
  onClick: () => void;
  payLink: string;
}

export default function LocalisedPaymentLink(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const { swap } = useLocalisedLink();
  const link = swap(props.payLink);
  return (
    <LinkButton variant="button" colour="primary" href={link} target="_blank" size="large">
      {t('CONTINUE_TO_PAYMENT_BUTTON', { defaultValue: 'Continue to Payment' })}
    </LinkButton>
  );
}
